<script lang="ts" setup>
import { defineProps, defineEmits } from "vue";
import { useI18n } from "vue-i18n";
import BaseFigureForIcon from "@/components/base/BaseFigureForIcon.vue";

const props = defineProps<{
  modelValue: boolean;
}>();

const emit = defineEmits<{
  (e: "update:modelValue", value: boolean): void;
}>();

const { t } = useI18n();

function toggle() {
  emit("update:modelValue", !props.modelValue);
}
</script>

<template>
  <div class="base-checkbox">
    <div
      class="base-checkbox--box"
      :class="{ active: modelValue }"
      @click="toggle"
    >
      <BaseFigureForIcon
        icon="check-checkbox"
        color="primary"
        size="small"
        radius="1px"
        class="base-checkbox--box-icon"
      />
    </div>
    <div class="base-checkbox--label">
      <p class="caption-small">
        {{ t("base.checkbox.consent") }}
      </p>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/style/main";

.base-checkbox {
  display: flex;
  gap: 16px;
  align-items: center;

  &--box {
    width: 24px;
    height: auto;
    border-radius: 2px;
    border: 1px solid var(--color-text-secondary);
    cursor: pointer;
    display: flex;

    &-icon {
      transition: opacity 0.2s;
      opacity: 0;
    }

    &.active {
      border-color: transparent;

      .base-checkbox--box-icon {
        opacity: 1;
      }
    }
  }

  &--label {
    p {
      color: var(--color-secondary);
    }
  }
}
</style>
